<div [style.background-color]="selectedStations.has(station) ? 'green' : 'gray'">
  <sc-padding>
    <sc-flex>
      <div>{{station.name}}</div>
    </sc-flex>
  </sc-padding>
</div>